export const getMonthAbbreviation = (monthNumber: number) => {
  const monthNames = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];
  return monthNames[monthNumber - 1] || null;
};
